import { ClientLambdaApi } from '@/api-client.js'
import moment from 'moment'

export const sales = {
  salesTwoRanges (payload) {
    return ClientLambdaApi.post('/sales-two-ranges/',
      { parameters: payload.parameters },
      { needTokenValidation: true })
      .then(response => {
        if (response.status !== 200) {
          throw new Error('Error al obtener el status de venta')
        }
        return response.data
      })
  },
  salesStatus () {
    return ClientLambdaApi.get('/sales-status/')
      .then(response => {
        if (response.status !== 200) {
          throw new Error('Error al obtener el status de venta')
        }
        return response.data
      })
  },
  pivotSales (parameters, pivotParameters) {
    return ClientLambdaApi.post('/pivot-sales/',
      { parameters: parameters.parameters, pivotParameters: parameters.pivotParameters },
      { needTokenValidation: true })
      .then(response => {
        if (response.status === 204) {
          throw new Error('No hay datos para la opción seleccionada')
        } else if (response.status !== 200) {
          throw new Error('Error en request pivot-sales')
        }
        return response.data
      })
  },
  dimFilter (parameters) {
    return ClientLambdaApi.post('/dimension-filter/',
      { parameters: parameters.parameters },
      { needTokenValidation: true })
      .then(response => {
        if (response.status === 204) {
          throw new Error('No hay datos para la opción seleccionada')
        } else if (response.status !== 200) {
          throw new Error('Error en request pivot-sales')
        }
        return response.data
      })
  },

  async salesGrowthDashboardIndicator (payload) {
    const response = await ClientLambdaApi.post('/sales-growth-dashboard-indicator/', { parameters: payload })
    if (response.status !== 200) {
      throw new Error('Error al obtener los indicadores del dashboard')
    }
    return response.data
  },

  async desktopDashboard (payload) {
    const response = await ClientLambdaApi.post('/desktop-dashboard/', { parameters: payload })
    if (response.status !== 200) {
      throw new Error('Error al obtener los datos del dashboard')
    }
    const { sales_growth_dashboard_indicators, sell_out_chart, store_growth, wm_product_count, stock_break_count, news_feed_indicators} = response.data
    return {
      salesGrowthDashboardIndicators: sales_growth_dashboard_indicators,
      sellOutChart: sell_out_chart,
      storeGrowth: store_growth,
      wmProductCount: wm_product_count.aggregation.product_count || 0,
      stockBreakCount: stock_break_count.aggregation.stock_break_status || 0,
      newsFeedIndicators: news_feed_indicators
    }
  },
}

export const general = {
  downloadGridToXlsx (parameters) {
    const download = require('js-file-download')
    return ClientLambdaApi.post('/download-grid-data-to-xlsx/', {
      parameters: parameters.parameters
    },
    { responseType: 'blob' })
      .then(response => {
        if (response.status !== 200) {
          throw new Error('Error al obtener excel con los datos de la grilla')
        }
        const ext = '.xlsx'
        const finalFileName = 'datos_grilla' + ext
        download(response.data, finalFileName)
      })
  },
  getDesktopParameterConfig () {
    const timeZoneOffsetMs = moment.utc().local().format('YYYY-MM-DD')
    return ClientLambdaApi.get(`/desktop-parameter-config/?clientDatetime=${timeZoneOffsetMs}`)
      .then(response => {
        if (response.status !== 200) {
          throw new Error('Error al obtener los parametros por defecto')
        }
        return response.data
      })
  },
  dwJobResultStatus () {
    return ClientLambdaApi.get('dw-job-result-status')
      .then(response => {
        if (response.status !== 200) {
          throw new Error('Error al consultar estado del trabajo DW')
        }
        return response.data
      })
  },
}

export const productAdmin = {
  async getProductMasterStatus () {
    const productMasterStatus = await ClientLambdaApi.get('/poll-product-master-status/')
    return productMasterStatus.data
  },
  async downloadProductMapLegacy (fileName) {
    const download = require('js-file-download')
    const xlsResponse =  await ClientLambdaApi.get('/generate-product-master-legacy/', {
      responseType: 'blob'
    })
    download(xlsResponse.data, `${fileName}.xlsx`)
  },


  updatePriceMaster (file, priceType, buildType) {
    const formData = new FormData()
    formData.append('file', file)
    return ClientLambdaApi.post(`/update-product-price?price_type=${priceType}&build_type=${buildType}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(response => {
        if (response.status !== 200) {
          throw new Error('Error al subir el maestro de productos')
        }
        return response.data
      })
  }
}




// WEBPACK FOOTER //
// ./src/services/api/ExpertoRetail.js